import { render, staticRenderFns } from "./EmailVerificationPage.vue?vue&type=template&id=5423bab4&scoped=true&"
import script from "./EmailVerificationPage.vue?vue&type=script&lang=ts&"
export * from "./EmailVerificationPage.vue?vue&type=script&lang=ts&"
import style0 from "./EmailVerificationPage.vue?vue&type=style&index=0&id=5423bab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423bab4",
  null
  
)

export default component.exports